// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".job-filter-card[data-v-6ae11ba0]{border-radius:15px!important;color:inherit}.job-filter-card .headline-sm[data-v-6ae11ba0]{margin:0 10px}[data-v-6ae11ba0] .v-card--link:focus:before{opacity:0!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
